module.exports = __webpack_public_path__ + "img/structure02.e732b08a.png";